import React, {useState, useRef} from "react"
import "./index.scss"
import config from "../../config"
import {OutsideClick} from "../../hooks/OutsideClick"
import {zendeskUrl} from "../../utils/utils"
import user_profile_icon from "../../assets/svg/user_profile_icon.svg"
import chevron_down from "../../assets/svg/chevron_down.svg"
import chevron_up from "../../assets/svg/chevron_up.svg"

const ProfileMenu = ({user}) => {
  const [openProfileMenuDropdown, setOpenProfileMenuDropdown] = useState(false)
  const userRef = useRef(null)

  const firstName = user?.split(" ")?.[0] ?? "Welcome"
  const dropdownToggleClass = openProfileMenuDropdown ? "show-dropdown" : "hide-dropdown"

  const handleProfileMenu = () => {
    setOpenProfileMenuDropdown(!openProfileMenuDropdown)
  }

  const handleSignOut = () => {
    setOpenProfileMenuDropdown(false)
    window.location.assign(config.api.SIGNOUT_URL)
    localStorage.removeItem("backdrop")
  }

  const handleHelp = () => {
    window.open(zendeskUrl, "_blank")
    setOpenProfileMenuDropdown(false)
  }

  OutsideClick(userRef, () => {
    setOpenProfileMenuDropdown(false)
  })

  return (
    <>
      <div
        className="profile-container"
        ref={userRef}
        data-testid="profile-menu-dropdown-test"
        onClick={handleProfileMenu}
      >
        <div className="profile-icon">
          <img
            src={user_profile_icon}
            alt="Profile Icon"
            data-testid="profile-icon-test"
          ></img>
        </div>
        <p className="user-name">{firstName}</p>
        <div data-testid="user-click" className="chevron-icon">
          <img
            src={openProfileMenuDropdown ? chevron_up : chevron_down}
            data-testid="chevron-test"
            alt="Arrow Icon"
          />
        </div>
        <div className={`${dropdownToggleClass} list-container`}>
          <div className="list">
            <ul>
              <li className="list-item" onClick={handleHelp} data-testid="help-test">
                Help
              </li>
              <li className="divider"></li>
              <li
                className="list-item"
                onClick={handleSignOut}
                data-testid="signout-test"
              >
                Sign Out
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfileMenu
